// ── UI event constants ────────────────────────────────────────────────────

export const FRACTIONAL_LEAVE_LIST_REFRESH_EVENT = 'fractional-leave-list-refresh' as const;

// ── Status filter constants (no magic strings) ────────────────────────────

export const FRACTIONAL_LEAVE_STATUS_FILTER = {
  ALL: 'all',
  ACTIVE: 'active',
  INACTIVE: 'inactive',
} as const;

export type FractionalLeaveStatusFilter =
  typeof FRACTIONAL_LEAVE_STATUS_FILTER[keyof typeof FRACTIONAL_LEAVE_STATUS_FILTER];


// ── Transport DTOs (match backend DTOs exactly) ────────────────────────────────────

/** Single fractional-leave item from backend */
export interface LC_FractionalLeaveItemOut {
  id: number;
  name: string | null;
  description: string | null;
  hours: string | null;
  deductible: boolean;
  isActive: boolean;
}

/** Payload for [BE-004] toggle status — PATCH /attendance/fractional-leave/{id}/estado */
export interface LC_FractionalLeaveToggleStatusIn {
  isActive: boolean;
}

/** Response of toggle status */
export interface LC_FractionalLeaveToggleStatusOut {
  id: number;
  name: string | null;
  description: string | null;
  hours: string | null;
  deductible: boolean;
  isActive: boolean;
  modifiedOn: string;
  modifiedBy: number | null;
}

/** Payload for create — POST /attendance/fractional-leave [BE-002] */
export interface LC_FractionalLeaveCreateIn {
  name: string;
  description: string | null;
  deductible: boolean | null;
  hours: string | null;
}

/** Response of create — 201 */
export interface LC_FractionalLeaveCreateOut {
  id: number;
  name: string | null;
  description: string | null;
  hours: string | null;
  deductible: boolean;
  isActive: boolean;
}

/** Payload for update — PUT /attendance/fractional-leave/{id} */
export interface LC_FractionalLeaveUpdateIn {
  name: string;
  description: string;
  hours: string | null;
  deductible: boolean | null;
  isActive: boolean | null;
}

/** Response of update */
export interface LC_FractionalLeaveUpdateOut {
  id: number;
  name: string | null;
  description: string | null;
  hours: string | null;
  deductible: boolean;
  isActive: boolean;
  modifiedOn: string;
  modifiedBy: number | null;
}

// ── Internal domain model ─────────────────────────────────────────────────

export interface FractionalLeave {
  id: number;
  name: string;
  description: string;
  hours: string;
  deductible: boolean;
  isActive: boolean;
}

export interface FractionalLeavePage {
  data: FractionalLeave[];
  totalRecords: number;
}

export interface FractionalLeaveListParams {
  page?: number;
  pageSize?: number;
  searchText?: string;
  statusFilter?: FractionalLeaveStatusFilter;
  sort?: {
    key: string;
    direction: 'asc' | 'desc';
  };
}

// ── Default page size ────────────────────────────────────────────────────

export const FRACTIONAL_LEAVE_DEFAULT_PAGE_SIZE = 10;
